import { api, RouterInputs, ReactQueryOptions } from '@api';
import { useSession } from '@shared/hooks/useSession';
type OptionsType = ReactQueryOptions['BlockManager']['isBlockedBy'];
type InputType = RouterInputs['BlockManager']['isBlockedBy'];
export const useGetIsBlockedBy = (input: InputType, options?: OptionsType) => {
  const {
    status
  } = useSession();
  const {
    data
  } = api.BlockManager.isBlockedBy.useQuery(input, {
    ...options,
    queryKey: ['BlockManager.isBlockedBy', input],
    refetchOnReconnect: true,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    enabled: status === 'authenticated' && options?.enabled
  });
  return {
    isBlocked: data?.status === 'success' ? data.isBlocked : false
  };
};